import React from 'react'
import './Profesionales.css'
import Header from '../Header/Header'
import Profecionales from '../../Components/Admin/Profecionales/Profecionales'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Pacientes() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <Profecionales />
                </div>
            </section>
        </div>
    )
}
